<template lang="pug">
  .Paragraph.Paragraph-margin.ParagraphWysisyg
    div(v-html="item.get('attributes.content.processed')")

</template>

<script>
import scrollUpdate from '@/mixins/scrollUpdate'

export default {
  props: ['item'],
  mixins: [scrollUpdate],
  data () {
    return {}
  },
  mounted () {
    let elements = this.$el.querySelectorAll('blockquote')
    for (let i = 0; i < elements.length; i++) {
      this.$parallax.set(
        elements[i],
        { y: 0, opacity: 1 },
        { y: -60, opacity: 0 },
        { y: 0, opacity: 1 },
        null,
        0.25
      )
    }
  },
  beforeDestroy () {
    let elements = this.$el.querySelectorAll('blockquote')
    for (let i = 0; i < elements.length; i++) {
      this.$parallax.remove(elements[i])
    }
  }
}

</script>

<style lang="stylus">
/**
 * ATTENTION - STYLES NOT SCOPED
 */

.ParagraphWysisyg
  box-sizing border-box
  padding 0 20px
  max-width: 910px

  div:first-child

    width 100%

  @media $mq_m
    padding 0 40px

  .text-highlight

    background-color #FFEFCE
    padding 100px 120px
    text-align center
    font-weight 400
    box-sizing border-box

  .baseline-simple

    font-weight 600

  a

    color $black
    font-weight 600
    transition opacity 0.6s $ease

    &:hover

      opacity 0.6

  .button-main, .button-secondary

    border-radius 50px
    display initial
    color $black
    font-weight 400!important
    margin 15px 20px
    text-decoration none
    letter-spacing 1px
    border 1px solid $black
    padding 10px 30px
    transition all 0.8s $ease

    &:hover

      color $beige
      background-color $black
      opacity 1

  table

    width 100%
    max-width 100%
    border-bottom 1px solid $black
    padding-bottom 12px

    caption

      padding 20px 20px
      border-bottom 1px solid $black

    thead th

      padding 15px 20px
      text-align center

    thead

      display table-caption
      border-bottom 1px solid $black

      tr

        width 100%
        display: inline-table;

    tbody

      td

        padding 8px 20px
        text-align center

  img, video

    max-width 100%

  video, iframe

    width 100%
    min-height 30vw

  ul

    list-style-type: circle;

  ol

    counter-reset: list;

    li

      list-style-type: none;
      counter-increment: list;

    li:before

      content: counter(list) ".";
      margin-right 15px
      font-family: 'Sectra Display'
      font-size inherit

  li

    display list-item
    font-weight 300
    margin-bottom 15px!important
    margin-top 0px!important

    @media $mq_m

      margin-bottom 20px!important
      margin-top 0px!important

    @media $mq_l

      margin-bottom 30px!important
      margin-top 0px!important

    ul, ol

      margin-top 15px

      @media $mq_m

        margin-top 20px

      @media $mq_l

        margin-top 30px

  h3

    margin-top 30px

    @media $mq_m
      margin-top 45px

    @media $mq_l
      margin-top 60px

  h4

    margin-top 30px

    @media $mq_m
      margin-top 45px

    @media $mq_l
      margin-top 60px

  p, li, a, table

    font-size 16px
    line-height 32px
    margin-top 20px

    @media $mq_m
      margin-top 35px
      font-size 20px
      line-height 40px

    @media $mq_l
      margin-top 50px

    strong,
    b
      font-size 18px
      line-height 34px
      font-family: 'Sectra Display'

      @media $mq_m
        font-size 22px
        line-height 45px

  blockquote
    max-width 340px
    position relative
    box-sizing border-box
    margin auto 40px auto auto
    font-size: 22px;
    line-height: 35px;
    font-family: 'Sectra Display'
    float left
    padding 65px 0

    @media $mq_l
      padding 115px 0
      font-size: 28px;
      line-height: 45px;

    &:after,
    &:before
      content ''
      display block
      transform scale(1)
      opacity 1
      transition transform 0.8s $ease
      position absolute
      left 0px
      font-size 90px
      color $beige

      @media $mq_l
        font-size 180px

    &:before
      content '"'
      top 0
      transform rotateZ(180deg) scale(1)

    &:after
      content '"'
      bottom 0

    p
      margin 0
      font-family: inherit
      font-size: inherit
      font-weight: inherit

      opacity 1
      transition opacity 0.8s 0.2s $ease

  // &.is-visible

  //   blockquote

  //     p

  //       opacity 1

  //     &:after,
  //     &:before

  //       transform scale(1)
  //       opacity 1

  //     &:before

  //       transform rotateZ(180deg) scale(1)

</style>
